import { inject, Injectable, OnDestroy } from '@angular/core';
import { assert } from '@sama/js-core';
import { isEmpty } from '@sama/micro-dash';
import { InjectableSuperclass } from '@sama/ng-core';
import { Sprite, SpriteMaterial, TextureLoader } from 'three';
import { Point3D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { GlobalRenderTriggerService } from '../../global-render-trigger.service';
import { RendererLayer, setRendererLayers } from '../../render-utils';
import { SceneControllerService } from '../../scene-controller.service';

@Injectable()
export class MissingShapeMarkerService
  extends InjectableSuperclass
  implements OnDestroy
{
  private sprite?: Sprite;
  private sceneControllerService = inject(SceneControllerService);
  private globalRenderTriggerService = inject(GlobalRenderTriggerService);

  ngOnDestroy() {
    if (this.sprite) {
      this.sceneControllerService.removeFromScene(this.sprite);
      this.sprite.geometry.dispose();
    }
  }

  setMissingShapeMarker(position: Point3D[]) {
    if (!this.sprite) {
      this.initializeSprite();
    }
    assert(this.sprite, 'Sprite should exist');

    if (isEmpty(position)) {
      setRendererLayers([], this.sprite);
    } else {
      this.sprite.position.fromArray(position[0]);
      setRendererLayers([RendererLayer.Main], this.sprite);
    }
    this.globalRenderTriggerService.trigger$.next();
  }

  private initializeSprite() {
    // TODO: assets are stored in sh3, in the future we need to develop a
    // pipeline to host our own assets
    const map = new TextureLoader().load(
      '/images/workspace-core/missing-shape-marker.png',
    );
    const material = new SpriteMaterial({ map });

    this.sprite = new Sprite(material);
    this.sprite.scale.set(1, 1, 1);
    this.sprite.center.set(0.5, 0);
    this.sprite.name = 'MissingShapeMarker';

    this.sceneControllerService.addToScene(this.sprite);
  }
}
